import React from "react";
import styles from "./DeviceStaticsChart.less";
import APILXD from "../../../http/APILXD";
import {Select, Input, DatePicker, message, Button, Modal, InputNumber} from "antd";
import AreaSelect from "../../../components/areaSelect/AreaSelect";
import ChartForCenterMsg from "./healthyChart/ChartForCenterMsg";
import ChartForScriptMsg from "./healthyChart/ChartForScriptMsg";
import ChartForRemoteMsg from "./healthyChart/ChartForRemoteMsg";
import ChartForRomMsg from "./healthyChart/ChartForRomMsg";
import ChartForFreeSizeMsg from "./healthyChart/ChartForFreeSizeMsg";
import ChartForCountryMsg from "./healthyChart/ChartForCountryMsg";
import DeviceByCondList from "./DeviceByCondList";
import dayjs from 'dayjs'
import HttpTool from "../../../tool/HttpTool";
import CookieHelp from "../../../tool/CookieHelp";

export default class DeviceStaticsChart extends React.Component {
  constructor(props) {
    super(props);

    let userInfo = CookieHelp.getUserInfo();
    this.role = userInfo && userInfo.info && userInfo.info.role || 2;

    this.state = {
      allRomIds: [],
      selRomIds: [],
      statusArr: [],
      area: null,
      sizeMaxG: null,
      sizeMaxMB: null,
      sizeMaxKB: null,
      sizeMinG: null,
      sizeMinMB: null,
      sizeMinKB: null,
      center: null,
      script: null,
      remote: null,
      centerOperator: 'eq',
      scriptOperator: 'eq',
      remoteOperator: 'eq',
      lasttime: dayjs().subtract(30, 'days'),
      tableKey: 0,  //控制表格更新
      searchParams: null,

    }

    this.userRoms = userInfo && userInfo.info && userInfo.info.romIds || [];
  }

  componentDidMount() {
    this.refetchData()

    if (this.role === 1) {
      this.getAllHeartBeatRomIds()
    }
  }

  refetchData() {
    let {selRomIds, statusArr, area, sizeMaxG, sizeMaxMB, sizeMaxKB, sizeMinG, sizeMinMB, sizeMinKB,center,script,remote,centerOperator,scriptOperator,remoteOperator, lasttime} = this.state;

    let maxSize = ((sizeMaxG || 0) * 1024 * 1024 * 1024 + (sizeMaxMB || 0) * 1024 * 1024 + (sizeMaxKB || 0) * 1024) || null;
    let minSize = ((sizeMinG || 0) * 1024 * 1024 * 1024 + (sizeMinMB || 0) * 1024 * 1024 + (sizeMinKB || 0) * 1024) || null;

    if(maxSize && minSize && maxSize<minSize){
      message.warn("剩余空间筛选项有冲突，请检查");
      return;
    }

    let searchParams = {
      romIds: selRomIds,
      statusArr: statusArr,
      freeSizeMax: maxSize,
      freeSizeMin: minSize,
      countryId: area && area.countryId || null,
      provinceId: area && area.provinceId || null,
      cityId: area && area.cityId || null,
      lasttime: lasttime? lasttime.valueOf() : null,
    }

    if(centerOperator === 'eq' && center){
      searchParams.center = center;
    }else if(centerOperator === 'eqNull'){
      searchParams.center = null;
    }

    if(scriptOperator === 'eq' && script){
      searchParams.script = script;
    }else if(scriptOperator === 'eqNull'){
      searchParams.script = null;
    }

    if(remoteOperator === 'eq' && remote){
      searchParams.remote = remote;
    }else if(remoteOperator === 'eqNull'){
      searchParams.remote = null;
    }

    this.chartForCenter && this.chartForCenter.getData(searchParams)
    this.chartForScript && this.chartForScript.getData(searchParams)
    this.chartForRemote && this.chartForRemote.getData(searchParams)
    this.chartForRom && this.chartForRom.getData(searchParams)
    this.chartForFreeSize && this.chartForFreeSize.getData(searchParams)
    this.chartForCountry && this.chartForCountry.getData(searchParams)

    this.setState({
      tableKey: this.state.tableKey + 1,
      searchParams: searchParams,
    })
  }

  getAllHeartBeatRomIds() {
    HttpTool.post(APILXD.getDeviceRomIdList, (code, msg, json) => {
      this.setState({
        allRomIds: json
      })
    }, (code, msg) => {
      message.error(msg);
    }, {})
  }


  render() {
    let {
      allRomIds,
      selRomIds,
      statusArr,
      area,
      sizeMaxG,
      sizeMaxMB,
      sizeMaxKB,
      sizeMinG,
      sizeMinMB,
      sizeMinKB,
      center,
      script,
      remote,
      centerOperator,
      scriptOperator,
      remoteOperator,
      lasttime,
      tableKey
    } = this.state;
    let couldSelRom = this.role === 1 ? allRomIds : this.userRoms;
    return <div className={styles.mainPage}>
      <div className={styles.header}>
        <div className={styles.flexLine}>
          <div className={styles.flexItem}>系统：
            <Select
              allowClear={true}
              placeholder={"选择系统过滤"}
              style={{width: "200px"}}
              mode={"multiple"}
              value={selRomIds}
              onChange={(value) => {
                this.setState({
                  selRomIds: value
                })
              }}
            >
              {
                couldSelRom.map((o) => {
                  return <Select.Option
                    key={o}
                    value={o}
                  >
                    {o}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className={styles.flexItem}>在线状态依据：
            <Select
              allowClear={true}
              placeholder={"选择状态过滤"}
              style={{width: "200px"}}
              mode={"multiple"}
              value={statusArr}
              onChange={(value) => {
                this.setState({
                  statusArr: value
                })
              }}
            >
              <Select.Option value={1}>离线</Select.Option>
              <Select.Option value={2}>空闲</Select.Option>
              <Select.Option value={3}>忙碌</Select.Option>
            </Select>
          </div>
          <div className={styles.flexItem}>地区过滤：
            <div style={{width: "400px"}}>
              <AreaSelect
                ref={(ref)=>{this.areaSel = ref}}
                onChange={(value) => {
                  this.setState({
                    area: value
                  })
                }}
              />
            </div>
          </div>
          <div className={styles.flexItem}>Center版本：
            <Select
              style={{width: "100px"}}
              value={centerOperator}
              onChange={(value) => {this.setState({
                centerOperator: value,
                center: ['eqNull'].includes(value)?null: center
              })}}
            >
              <Select.Option value={'eq'}>包含</Select.Option>
              <Select.Option value={'eqNull'}>只查未知</Select.Option>
            </Select>
            <Input
              disabled={centerOperator === 'eqNull'}
              style={{width: "200px"}}
              placeholder={"请输入"}
              value={center}
              onChange={(e) => {
                this.setState({
                  center: e.target.value
                })
              }}
            />
          </div>
          <div className={styles.flexItem}>Script版本：
            <Select
              style={{width: "100px"}}
              value={scriptOperator}
              onChange={(value) => {this.setState({
                scriptOperator: value,
                script: ['eqNull'].includes(value)?null: script
              })}}
            >
              <Select.Option value={'eq'}>包含</Select.Option>
              <Select.Option value={'eqNull'}>只查未知</Select.Option>
            </Select>
            <Input
              disabled={scriptOperator === 'eqNull'}
              style={{width: "200px"}}
              placeholder={"请输入"}
              value={script}
              onChange={(e) => {
                this.setState({
                  script: e.target.value
                })
              }}
            />
          </div>
          <div className={styles.flexItem}>Remote版本：
            <Select
              style={{width: "100px"}}
              value={remoteOperator}
              onChange={(value) => {this.setState({
                remoteOperator: value,
                remote: ['eqNull'].includes(value)?null: remote
              })}}
            >
              <Select.Option value={'eq'}>包含</Select.Option>
              <Select.Option value={'eqNull'}>只查未知</Select.Option>
            </Select>
            <Input
              disabled={remoteOperator === 'eqNull'}
              style={{width: "200px"}}
              placeholder={"请输入"}
              value={remote}
              onChange={(e) => {
                this.setState({
                  remote: e.target.value
                })
              }}
            />
          </div>
          <div className={styles.flexItem}>大于剩余空间：
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMinG}
              onChange={(value) => {
                this.setState({
                  sizeMinG: value
                })
              }}
            />
            G
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMinMB}
              onChange={(value) => {
                this.setState({
                  sizeMinMB: value
                })
              }}
            />
            MB
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMinKB}
              onChange={(value) => {
                this.setState({
                  sizeMinKB: value
                })
              }}
            />
            KB
          </div>
          <div className={styles.flexItem}>小于剩余空间：
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMaxG}
              onChange={(value) => {
                this.setState({
                  sizeMaxG: value
                })
              }}
            />
            G
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMaxMB}
              onChange={(value) => {
                this.setState({
                  sizeMaxMB: value
                })
              }}
            />
            MB
            <InputNumber
              min={0}
              placeholder={"请输入"}
              value={sizeMaxKB}
              onChange={(value) => {
                this.setState({
                  sizeMaxKB: value
                })
              }}
            />
            KB
          </div>
          <div className={styles.flexItem}>此日期后上线过：
            <DatePicker
              value={lasttime}
              showToday={false}
              format={"YYYY-MM-DD"}
              disabledDate={((currentDate) => {
                return (currentDate && currentDate.valueOf() >= (Date.now() - 86400000)) || (currentDate && currentDate.valueOf() <= (Date.now() - 86400000 * 180))
              })}
              onChange={(date, dateString) => {
                this.setState({
                  lasttime: date
                })
              }}
            />
          </div>
          <Button
            type={"primary"}
            onClick={()=>{
              this.refetchData()
            }}
          >开始过滤</Button>
          <Button
            type={"primary"}
            ghost={true}
            onClick={()=>{
              this.areaSel && this.areaSel.changeValue('country', null)

              this.setState({
                selRomIds: [],
                statusArr: [],
                area: null,
                sizeMaxG: null,
                sizeMaxMB: null,
                sizeMaxKB: null,
                sizeMinG: null,
                sizeMinMB: null,
                sizeMinKB: null,
                center: null,
                script: null,
                remote: null,
                centerOperator: 'eq',
                scriptOperator: 'eq',
                remoteOperator: 'eq',
                lasttime: dayjs().subtract(30, 'days'),
              },()=>{
                this.refetchData()
              })
            }}
          >重置筛选</Button>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.chartGroupBox}>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                Center型号分布
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForCenterMsg
                  ref={(ref)=>{this.chartForCenter = ref}}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                Script版本号分布
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForScriptMsg
                ref={(ref)=>{this.chartForScript = ref}}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                Remote版本号分布
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForRemoteMsg
                ref={(ref)=>{this.chartForRemote = ref}}
              />
            </div>
          </div>
        </div>
        <div className={styles.chartGroupBox}>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                数量前TOP20国家
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForCountryMsg
                ref={ref => this.chartForCountry = ref}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                型号分布
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForRomMsg
                ref={(ref)=>{this.chartForRom = ref}}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div className={styles.chartHeadBox}>
              <div className={styles.chTitle}>
                剩余空间分布
              </div>
            </div>
            <div
              className={styles.chartBodyBox}
            >
              <ChartForFreeSizeMsg
                ref={(ref)=>{this.chartForFreeSize = ref}}
              />
            </div>
          </div>
        </div>
        <div
          className={styles.chartGroupBox}
        >
          <div
            style={{width: "100%"}}
          >
            <DeviceByCondList
              {...this.props}
              key={tableKey}
              requestParams={this.state.searchParams}
            />
          </div>
        </div>
      </div>
    </div>
  }
}